import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import arrowIcon from "src/assets/images/icon_arrow_right.svg";
import introImage from "src/assets/images/staking_intro.png";
import introImage2 from "src/assets/images/staking_intro2.svg";
import { useTypeWritter } from "src/hooks/useTypeWritter";
import { CustomButton } from "./CustomButton";

export const StakingIntro = () => {
  const typing: any = useTypeWritter(["Node Operator", "PoS Validator", "Data Provider", "API Provider", "Web3 Builder"])
  return (  
      <Box style={{
        margin:"auto"
      }} width="1280px" pt="115px" pl="40px" pb="185px" position="relative" >
        <Typography
          variant="bold"
          fontSize="40px"
          color="#0E1011"
          alignSelf="flex-start"
          lineHeight="40px"
        >
          A Web3 Infrastructure Provider
        </Typography>

        <Typography color="#797979" fontSize="22px" lineHeight="22px" mt="28px">
          Professional Web3 Service Provider since 2018
        </Typography>

        <Box
          mt="64px"
          mb="70px"
          color="#0E1011"
          fontSize="24px"
          height="36px"
          display="flex"
        >

          <label>{typing}</label>  <div className="stakingIntro_cursor">

          </div>
        </Box>

        {/* <CustomButton
        fontSize="20px"
        padding="12px 32px"
        onClick={() => {
          window.open("/Wetez_onepage.pdf");
        }}
      >
        Introduction
      </CustomButton>

      <Stack direction="row" mt="18px" alignItems="center">
        <Box width="7px">
          <img src={arrowIcon} width="100%" alt="icon" />
        </Box>

        <Typography color="secondary" fontSize="20px" ml="8px">
          Explore staking services provided by
        </Typography>

        <Typography variant="bold" fontSize="20px" color="primary" ml="4px">
          Wetez
        </Typography>
      </Stack> */}

        <Box position="absolute" bottom="0px" right="-40px">
          <img src={introImage2} width="600px" height="523px" alt="intro" />
        </Box>
      </Box> 
  );
};
